/**
 * @title:
 * @fileName: ppm
 * @projectName WEB
 * @author ：yaaynn
 * @date ：2020/6/28 15:12
 * @modified By：
 * @version:     1.0$
 * @description: TODO
 */
class Ppm {
    constructor(hostname, path = '/api') {
        this._api = hostname + path
    }

    get verify (){
        return this._api + '/pavementmdpm/existstestdata'
    }
}
export default Ppm
